(function ($) {
  Drupal.behaviors.estee_edit_moodboard_formatter_v1 = {
    attach: function (context, settings) {

    } // attach
  };
})(jQuery);
